import * as Yup from "yup"
import {
  emailNotLongEnough,
  invalidEmail,
  emailTooLong,
  maxCharacters,
  minCharacters,
} from "../constants/validationMessages"
import { EMPTY_EMAIL_ADDRESS } from "../constants/messages"

export const InviteeEmailValidation = Yup.object().shape({
  inviteeEmail: Yup.string()
    .min(minCharacters, emailNotLongEnough)
    .max(maxCharacters, emailTooLong)
    .email(invalidEmail)
    .required(EMPTY_EMAIL_ADDRESS),
})
